import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { sendEmail, isSameOrAfterCurrentMonth, formatBookingCreated } from '../utils';
import { availableTimes, ENTITIES } from '../constants';
import EntityManager from '../components/manage-items/EntityManager';
import BookingsTab from '../components/manage-items/tabs/BookingsTab';
import MemberFeesTab from '../components/manage-items/tabs/MemberFeesTab';
import Footer from '../components/Footer';
import { useAuth } from '../hooks/useAuth';
import { useManageOptions } from '../hooks/useManageOptions';

const ManageItemsView = () => {
  useEffect(() => {
    document.title = 'The Club - Manage items';
  }, []);

  const { user } = useAuth();
  const { t, i18n } = useTranslation();

  const [activeTab, setActiveTab] = useState('users');
  const [selectedDate, setSelectedDate] = useState(new Date());

  const { priceGroupOptions, memberTypeNames } = useManageOptions();

  const getOptionLabel = (key, option) => {
    switch (key) {
      case 'price_group':
        return priceGroupOptions[option] ? priceGroupOptions[option] : 'Välj';
      case 'type_of_member': {
        const nameType = memberTypeNames.find((item) => item.id === option);
        return nameType && nameType.type_of_object ? nameType.type_of_object : '';
      }
      case 'bookable':
        return option === 'Välj' ? option : option === '1' ? 'Ja' : 'Nej';
      case 'timeId': {
        const timeId = availableTimes.find((item) => item.id === option);
        return timeId ? timeId.type_of_object : option;
      }
      case 'bookingTimestamp':
        return formatBookingCreated(option);
      case 'member_payment_handeld_date':
        return isSameOrAfterCurrentMonth(selectedDate, option) ? option : '-';
      default:
        return option;
    }
  };

  const handleUserAdded = (formData) => {
    sendEmail({
      type: 'user-added',
      username: formData.firstname,
      email: formData.email,
      lang: i18n.language,
      formData: { type: 'user-added' }
    });
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'bookings':
        return (
          <BookingsTab
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            userEmail={user?.userInfo?.email}
            getOptionLabel={getOptionLabel}
            memberTypeNames={memberTypeNames}
          />
        );
      case 'memberFees':
        return (
          <MemberFeesTab
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            lang={i18n.language}
            userEmail={user?.userInfo?.email}
            getOptionLabel={getOptionLabel}
            memberTypeNames={memberTypeNames}
          />
        );
      default:
        return (
          <EntityManager
            entityKey={activeTab}
            selectedDate={selectedDate}
            userEmail={user?.userInfo?.email}
            getOptionLabel={getOptionLabel}
            memberTypeNames={memberTypeNames}
            onUserAdded={handleUserAdded}
          />
        );
    }
  };

  return (
    <>
      <div id="select-manage-button" className="wrapper-width-small">
        {Object.entries(ENTITIES).map(([key, entity]) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            className={`${activeTab === key && 'selected-button'} selectable-button bold`}
          >
            {t(entity.name)}
          </button>
        ))}
      </div>

      {renderActiveTab()}

      <Footer user={user} />
    </>
  );
};

export default ManageItemsView;
export { ManageItemsView };
